import { useToggle } from 'ahooks';
import { message } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { getTotalBalance } from '@/services/subAccount';
import { IBaseResponse } from '@/services/types/common';
import { ITotalBalance } from '@/services/types/subAccount';
import { isShowCreateSubAccount } from '@/utils/pageConfig/subAccount/helper/action';

// 总资产card hook
export function useTotalBalance() {
  const navigate = useNavigate();
  const [isHide, { toggle }] = useToggle<boolean>(false);
  const [visible, setVisible] = useState<boolean>(
    isShowCreateSubAccount() === 'selectModal',
  );
  /**现货总法币 */
  const [totalBalance, setTotalBalance] = useState<string | number>(0);
  /**合约总btc */
  const [contractTotalBalance, setContractTotalBalance] =
    useState('0.00000000');

  const toTransferRecord = () => {
    window.location.href = '/user/assets/subAccountTransferRecord';
  };

  const toBindRequest = () => {
    navigate('/app/user/bind-request');
  };

  const getTotalBalanceFn = () => {
    // 获取总资产
    getTotalBalance()
      .then((res: IBaseResponse<ITotalBalance>) => {
        if (res?.result) {
          setContractTotalBalance(res?.result?.totalBalanceBtc);
          setTotalBalance(res.result.totalBalanceUsdt);
        }
      })
      .catch((error) => {
        message.error(`${error?.ret_code}: ${error?.ret_msg}`);
      });
  };

  useEffect(() => {
    getTotalBalanceFn();
  }, []);

  return {
    isHide,
    visible,
    totalBalance,
    contractTotalBalance,
    toggle,
    setVisible,
    toTransferRecord,
    toBindRequest,
    updatedTotalBalance: getTotalBalanceFn,
  };
}
